/**
 * HomeV2Page — A/B test landing at `/home` (unlinked from site nav).
 *
 * Same overall page composition as `LandingPage` but the hero is swapped
 * for the 4-step upload → goal → audit-preview → makeover flow. Seeded
 * by ad campaigns; SEO-noindex so it doesn't compete with `/`.
 */
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppShell } from '../components/Layout';
import { useAuth } from '../lib/auth-context';

import { HomeHero4Step } from '../components/landing/HomeHero4Step';
import { MarqueeStrip } from '../components/landing/MarqueeStrip';
import { PromiseSection } from '../components/landing/PromiseSection';
import { FeatureShowcase } from '../components/landing/FeatureShowcase';
import { MidScrollCTA } from '../components/landing/MidScrollCTA';
import { PersonasSection } from '../components/landing/PersonasSection';
import { PricingSection } from '../components/landing/PricingSection';
import { EverythingInOneSittingSection } from '../components/landing/EverythingInOneSittingSection';
import { FAQSection } from '../components/landing/FAQSection';
import { FinalCTA } from '../components/landing/FinalCTA';
import SeoHead from '../components/seo/SeoHead';

export default function HomeV2Page() {
  const navigate = useNavigate();
  const { user } = useAuth() || {};
  const onPrimaryCta = useMemo(
    () => () => {
      if (user) navigate('/dashboard');
      else navigate('/signup');
    },
    [navigate, user]
  );

  return (
    <AppShell>
      <SeoHead
        title={"Blayzrr — Get your LinkedIn Profile Makeover"}
        description={"Upload your LinkedIn PDF and get a 4-step audit + rewrite plan tailored to your goal — recruiter visibility, thought leadership or business development."}
        path={"/home"}
        robots="noindex, nofollow"
      />
      <HomeHero4Step />
      <PersonasSection />
      <MarqueeStrip />
      <FeatureShowcase />
      <PromiseSection />
      <MidScrollCTA variant="trial" onPrimaryCta={onPrimaryCta} />
      <PricingSection />
      <EverythingInOneSittingSection onPrimaryCta={onPrimaryCta} />
      <FAQSection />
      <FinalCTA onPrimaryCta={onPrimaryCta} />
    </AppShell>
  );
}
